<template>
  <el-input v-model="string" />
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String],
      required: false,
      default: "",
    },
  },
  computed: {
    string: {
      get() {
        if (this.value.length && Array.isArray(this.value))
          return this.value.join(",");
        if (!this.value.length && Array.isArray(this.value)) return "";
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
